import styled from "styled-components";

const Container = styled.main`
    padding-top: 72px;
    padding-left: 95px;
`;

export default Container;